import { Injectable } from '@angular/core';
import { PlacesComponent } from '../components/places/places.component';
// import { DataService } from './data.service';
// import { ColorService } from './color.service';
// import { MapComponent } from '../components/map/map.component';
// import { GraphManagerComponent } from '../components/graph-manager/graph-manager.component';
// import { GraphPe1Component } from '../components/graph-pe1/graph-pe1.component';
// import { GraphPe2Component } from '../components/graph-pe2/graph-pe2.component';
// import { GraphDimoiComparedComponent } from '../components/graph-dimoi-compared/graph-dimoi-compared.component';
// import { PropertySelectorComponent } from '../components/property-selector/property-selector.component';


// import { TimeService } from './time.service';

@Injectable()
export class ContextService {
  private _places: PlacesComponent;
  // private _map: MapComponent;
  // private _graphManger: GraphManagerComponent;
  // private _graphPe1: GraphPe1Component;
  // private _graphPe2: GraphPe2Component;
  // private _propertySelector: PropertySelectorComponent;
  // private _graphDimoiCompared: GraphDimoiComparedComponent;
  // constructor(public timeService: TimeService, public colorService: ColorService) {

  // }

  set places(p: PlacesComponent) { this._places = p; }
  get places() { return this._places; }
  // set map(m: MapComponent) { this._map = m; }
  // get map() { return this._map; }
  // set graph(g: GraphManagerComponent) { this._graphManger = g; }
  // set graphDimoiCompared(g: GraphDimoiComparedComponent) { this._graphDimoiCompared = g; }
  // set graphPe1(g: GraphPe1Component) { this._graphPe1 = g; }
  // set graphPe2(g: GraphPe2Component) { this._graphPe2 = g; }

  // set propertySelector(ps: PropertySelectorComponent) { this._propertySelector = ps; }
  // get propertySelector() { return this._propertySelector; }

  timeChanged() {
    // this._map.redraw();
    // this._graphDimoiCompared.redraw();
  }


  dataUpdated() {
    // if (this._graphManger) {
    //   this._graphManger.redraw();
    // }
    // this._graphPe1.redraw();
    // this._graphPe2.redraw();
  }


}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-data-entry/src/app/services/context.service.ts